const TONE = {
  out: "bg-red-700/15 text-red-700 border-red-700/30",
  critical: "bg-red-600/15 text-red-600 border-red-600/30",
  low: "bg-amber-500/15 text-amber-600 border-amber-500/30",
  healthy: "bg-emerald-600/15 text-emerald-700 border-emerald-600/30",
  excess: "bg-blue-900/15 text-blue-900 border-blue-900/30",
};

const DOT = {
  out: "#b91c1c",
  critical: "#dc2626",
  low: "#d97706",
  healthy: "#15803d",
  excess: "#1e3a8a",
};

// Plain words, for employees who do not work with stores or accounts language.
const LABEL = {
  out: "Finished",
  critical: "Very Low",
  low: "Low Stock",
  healthy: "Enough Stock",
  excess: "Too Much Stock",
};

export const STATUS_COLOUR = DOT;
export const STATUS_LABEL = LABEL;

export function StatusPill({ status = "healthy", label, testId }) {
  const key = TONE[status] ? status : "healthy";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide ${TONE[key]}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: DOT[key] }} />
      {label || LABEL[key]}
    </span>
  );
}

export function StatusLegend() {
  return (
    <div className="flex flex-wrap items-center gap-3 text-[11px] text-muted-foreground"
      data-testid="stock-status-legend">
      {["out", "critical", "low", "healthy", "excess"].map((s) => (
        <span key={s} className="flex items-center gap-1">
          <span className="h-2 w-2 rounded-full" style={{ background: DOT[s] }} />
          {LABEL[s]}
        </span>
      ))}
    </div>
  );
}
